import React from 'react'
import Grid from './Grid'
import teamConfig from '../../configs/team-config'
import protegeConfig from '../../configs/protege-config'

const Team = ({columnCount, selectedIndex, protegeIndex, protegeHandler, clickHandler}) => {

  return (
    <div className="team-section">
      <div className="team-header">
        <h1>MEET OUR TEAM</h1>
        <p>Mind Makers is made possible thanks to an international collaboration between engineers, educators and artists of all sorts, joined by a common vision.</p>
      </div>
      <div className="team-grid">
        <Grid
          clickHandler={clickHandler}
          columnCount={columnCount}
          selectedIndex={selectedIndex}
          teamArray={teamConfig}
        />
      </div>  
      <div className="team-header">
        <h1>MEET OUR PROTÉGÉS</h1>
        <p>Youth STEM leaders that we collaborate with, mentor and support.</p>
      </div>
      <div className="team-grid">
        <Grid
          clickHandler={protegeHandler}
          columnCount={columnCount}
          selectedIndex={protegeIndex}
          teamArray={protegeConfig}
        />
      </div>
    </div>
  )
}

export default Team


// WEBPACK FOOTER //
// ./src/components/About/Team.js